import { useState } from "react";
import { X } from "lucide-react";

const COLORS = ["#FF5500", "#00E676", "#FFEA00", "#2979FF", "#FF1744", "#B0B0B0", "#A855F7"];

export default function GroupModal({ open, group, onClose, onSave }) {
    const [name, setName] = useState(group?.name || "");
    const [color, setColor] = useState(group?.color || COLORS[0]);

    if (!open) return null;

    const handleSave = () => {
        if (!name.trim()) return;
        onSave({ name: name.trim(), color });
    };

    return (
        <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/80 backdrop-blur-md">
            <div className="w-[420px] max-w-[92vw] bg-[#0A0A0A] border-2 border-virtus-orange">
                <div className="flex items-center justify-between px-5 py-3 border-b border-virtus-line">
                    <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-virtus-orange">
                        {group ? "EDIT GROUP" : "NEW GROUP"}
                    </div>
                    <button
                        onClick={onClose}
                        className="text-virtus-dim hover:text-virtus-orange"
                        aria-label="Close"
                    >
                        <X size={16} />
                    </button>
                </div>
                <div className="p-5 space-y-4">
                    <div>
                        <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-virtus-dim mb-2">
                            Name
                        </div>
                        <input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Group 1"
                            className="w-full bg-transparent border border-virtus-line focus:border-virtus-orange px-3 py-2 text-white outline-none"
                            data-testid="group-name-input"
                            autoFocus
                        />
                    </div>
                    <div>
                        <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-virtus-dim mb-2">
                            Color
                        </div>
                        <div className="flex gap-2">
                            {COLORS.map((c) => (
                                <button
                                    key={c}
                                    onClick={() => setColor(c)}
                                    className={`w-8 h-8 border-2 ${color === c ? "border-white" : "border-transparent"}`}
                                    style={{ backgroundColor: c }}
                                    aria-label={c}
                                />
                            ))}
                        </div>
                    </div>
                </div>
                <div className="flex items-center justify-end gap-3 px-5 py-3 border-t border-virtus-line">
                    <button
                        onClick={onClose}
                        className="font-mono text-[10px] tracking-[0.22em] uppercase text-virtus-dim hover:text-white px-3 py-2"
                    >
                        CANCEL
                    </button>
                    <button
                        onClick={handleSave}
                        className="font-mono text-[10px] tracking-[0.22em] uppercase bg-virtus-orange text-black px-4 py-2 hover:bg-white glow-orange"
                        data-testid="group-save-btn"
                    >
                        SAVE
                    </button>
                </div>
            </div>
        </div>
    );
}
